export const baseLine = 1.5

export const lineRems = (lines: number): string => `${lines * baseLine}rem`
